var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-nav mb-5 mb-chat site-width"},[_c('h1',{staticClass:"mb-4"},[_vm._v("Projects")]),_c('ProjectsWidget',{attrs:{"query":_vm.query},on:{"update:query":function($event){_vm.query=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }